import {
  TOKEN_CONTAINER_PADDING_PX,
  TOKEN_PAPER_WIDTH_PX,
} from "../../utils/tokenPrintPaper";

/** Default vertical layout for 80mm token slip (container height 380px) */
const initialState = {
  printPosition: {
    container: {
      top: 380,
      left: TOKEN_PAPER_WIDTH_PX,
      show: true,
      size: 50,
      title: "container",
      name: "container",
    },
    logo: {
      top: 10,
      left: 0,
      show: true,
      size: 40,
      title: "logo",
      name: "clinic Logo",
    },
    header: {
      top: 56,
      left: 0,
      show: true,
      size: 25,
      title: "header",
      name: "Clinic Name",
    },
    doctor: {
      top: 88,
      left: 0,
      show: true,
      size: 16,
      title: "doctor",
      name: "Doctor Name",
    },
    tokenNotext: {
      top: 118,
      left: 0,
      show: true,
      size: 14,
      title: "tokenNotext",
      name: "Token Label",
    },
    tokenNo: {
      top: 130,
      left: 0,
      show: true,
      size: 80,
      title: "tokenNo",
      name: "Token Number",
    },
    roomNumber: {
      top: 210,
      left: 0,
      show: true,
      size: 15,
      title: "roomNumber",
      name: "Room Number",
    },
    patientName: {
      top: 228,
      left: 0,
      show: true,
      size: 13,
      title: "patientName",
      name: "Patient Name",
    },
    datetime: {
      top: 250,
      left: 0,
      show: true,
      size: 13,
      title: "datetime",
      name: "Date & Time",
    },
    website: {
      top: 270,
      left: 0,
      show: true,
      size: 13,
      title: "website",
      name: "Website",
    },
    email: {
      top: 290,
      left: 0,
      show: true,
      size: 13,
      title: "email",
      name: "Email",
    },
    phoneOne: {
      top: 310,
      left: 0,
      show: true,
      size: 13,
      title: "phoneOne",
      name: "Phone 1",
    },
    phoneTwo: {
      top: 330,
      left: 0,
      show: true,
      size: 13,
      title: "phoneTwo",
      name: "Phone 2",
    },
    thankYou: {
      top: 350,
      left: 0,
      show: true,
      size: 13,
      title: "thankYou",
      name: "Thank You Message",
    },
    horizontallineone: {
      top: 34,
      left: 0,
      show: false,
      size: TOKEN_PAPER_WIDTH_PX - TOKEN_CONTAINER_PADDING_PX * 2,
      title: "horizontallineone",
      name: "Top Divider",
    },
    datetimetext: {
      top: 52,
      left: 0,
      show: false,
      size: 11,
      title: "datetimetext",
      name: "Date Title",
    },
    timetext: {
      top: 72,
      left: 0,
      show: false,
      size: 11,
      title: "timetext",
      name: "Time Title",
    },
    time: {
      top: 72,
      left: 0,
      show: false,
      size: 11,
      title: "time",
      name: "Time",
    },
    doctortext: {
      top: 92,
      left: 0,
      show: false,
      size: 11,
      title: "doctortext",
      name: "Doctor Title",
    },
    roomNumbertext: {
      top: 112,
      left: 0,
      show: false,
      size: 11,
      title: "roomNumbertext",
      name: "Room Title",
    },
    horizontallinetwo: {
      top: 134,
      left: 0,
      show: false,
      size: TOKEN_PAPER_WIDTH_PX - TOKEN_CONTAINER_PADDING_PX * 2,
      title: "horizontallinetwo",
      name: "Bottom Divider",
    },
  },
  clinic: {
    clinicName: "Cosmetic Dental Care International",
    tpNo: "",
    phoneTwo: "",
    website: "",
    email: "",
    address: "123 Main Street",
    drName: "Dr. Mayura Gamalath",
    thankYouMessage: "Thank you for your patience!",
    printImages: "",
    headerImages: "",
    footerImages: "",
  },
  token: {
    tokenNo: "13",
    roomNumber: "1",
    patientName: "Ms. ISMA HIDAYATH",
    issuedAt: new Date().toISOString(),
  },
};

type State = typeof initialState;
type TokenPrintAction =
  | {
      type: "SET_TOKENPRINT_ACTIONS";
      payload: {
        name: keyof State["printPosition"];
        target: keyof State["printPosition"][keyof State["printPosition"]];
        value: number | boolean | string;
      };
    }
  | {
      type: "SET_TOKENPRINT_CLINIC";
      payload: Partial<State["clinic"]>;
    }
  | {
      type: "SET_TOKENPRINT_TOKEN";
      payload: Partial<State["token"]>;
    };

export const tokenPrintReducer = (state = initialState, action: TokenPrintAction) => {
  switch (action.type) {
    case "SET_TOKENPRINT_ACTIONS": {
      const { name, target, value } = action.payload;
      if (!(name in state.printPosition)) return state;

      return {
        ...state,
        printPosition: {
          ...state.printPosition,
          [name]: {
            ...state.printPosition[name],
            [target]: value,
          },
        },
      };
    }
    case "SET_TOKENPRINT_CLINIC": {
      return {
        ...state,
        clinic: {
          ...state.clinic,
          ...action.payload,
        },
      };
    }
    case "SET_TOKENPRINT_TOKEN": {
      return {
        ...state,
        token: {
          ...state.token,
          ...action.payload,
        },
      };
    }
    default:
      return state;
  }
};
